import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import i18n from '../../i18n';
import Utils from '../../utils/utils';
import useGTM from '../analytics/useGTM';
import Analytics from '../../utils/analytics';
import User from '../../models/User';
import { NAVIGATION_ACTION, NAVIGATION_AREAS, NAVIGATION_TEXT } from '../analytics/analytics-constants';
import { Button } from '@homeexchange/design';

class OfflineFilters extends React.PureComponent {
    constructor(props) {
        super(props);
        this.signup = this.signup.bind(this);
        this.onTrackNavigationButton = this.onTrackNavigationButton.bind(this);
    }

    onTrackNavigationButton(text) {
        const { fetchNavigation } = useGTM(this.props.user);
        Analytics.trackGTM(
            'button',
            fetchNavigation(NAVIGATION_ACTION.CLICK, NAVIGATION_AREAS.FILTERS, text)
        );
    }

    signup(e) {
        if (e) {
            e.preventDefault();
        }

        this.onTrackNavigationButton(NAVIGATION_TEXT.SIGN_UP);
        document.dispatchEvent(new CustomEvent('open_signup_popup'));
    }

    render() {
        return (
            <a className="offline-filters-link" onClick={this.signup}>
                <div className="search-filters offline-filters">
                    <div className="offline-filters-left-block">
                        <div className="offline-filters-illustration">
                            <img
                                src={`${Utils.getAssetsDomain()}/images/website/search/sign_up_illustration.svg`}
                                alt=""
                            />
                        </div>
                        <div className="offline-filters-content">
                            <h4>{i18n.t('search:offline-filters.title')}</h4>
                            <p>{i18n.t('search:offline-filters.description')}</p>
                        </div>
                    </div>
                    <div className="offline-filters-action">
                        <Button onClick={this.signup}>{i18n.t('common:create_account')}</Button>
                    </div>
                </div>
            </a>
        );
    }
}

OfflineFilters.propTypes = {
    user: PropTypes.instanceOf(User)
};

const mapStateToProps = (state) => ({
    user: state.user
});

export default connect(mapStateToProps)(OfflineFilters);
